// import { BiBluetooth } from "react-icons/bi";
import styled from "styled-components/macro";
import {
  primary_brand,
  hoverSecondarySelect,
  error,
  errorBg,
  subtle_text,
} from "../Variables.Style";

interface InputProps {
  error?: any;
}

export const InputDiv = styled.div`
  display: flex;
  padding: 0px;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  margin: 5px 0;
`;

export const Label = styled.label<InputProps>`
  font-family: "Poppins", sans-serif;
  margin-bottom: 0px;
  color: ${(props) => (props.error ? `${error}` : "black")}; ;
`;

export const Input = styled.input<InputProps>`
  padding: 0.75rem 0.95rem;
  border-radius: 10px;
  outline: none;
  width: 100%;
  border: 0.8px solid #e8e8e8;
  border-color: ${(props) => (props.error ? " red" : "#e8e8e8")};
  background-color: ${(props) => (props.error ? "red" : "white")};
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.01);
  background: #ffffff;
  resize: none;
  outline: none;

  :focus {
    outline: none !important;
    border-color: ${primary_brand};
    opacity: ${(props) => (props.error ? 0.05 : 1)};
    border-color: ${(props) => (props.error ? " red" : `${primary_brand}`)};
    background-color: ${(props) => (props.error ? `${errorBg}` : "white")};
    /* ba */
    ::placeholder {
      color: ${(props) => (props.error ? `${error}` : `${subtle_text}`)};
    }
  }
  ::placeholder {
    color: ${(props) => (props.error ? `${error}` : `${subtle_text}`)};
    margin-left: 10px;
  }
`;
export const Textarea = styled.textarea<InputProps>`
  padding: 0.75rem 0.95rem;
  border-radius: 10px;
  outline: none;
  /* cols:"50"; */
  /* width: 100%; */
  width: 46vw;
  height: 15vh;
  border: 0.8px solid #e8e8e8;
  border-color: ${(props) => (props.error ? " red" : "#e8e8e8")};
  background-color: ${(props) => (props.error ? "red" : "white")};
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.01);
  background-color: white;
  resize: none;
  outline: none;

  :focus {
    outline: none !important;
    border-color: ${primary_brand};
    opacity: ${(props) => (props.error ? 0.05 : 1)};
    border-color: ${(props) => (props.error ? " red" : `${primary_brand}`)};
    background-color: ${(props) => (props.error ? `${errorBg}` : "white")};
    /* ba */
    ::placeholder {
      color: ${(props) => (props.error ? `${error}` : `${subtle_text}`)};
    }
  }
  ::placeholder {
    color: ${(props) => (props.error ? `${error}` : `${subtle_text}`)};
    margin-left: 10px;
  }
`;

export const TextColor = styled.span`
  font-size: 12px;
  height: 15px;
  color: red;
  display: block;
  padding-left: 5px;
  // text-transform: capitalize;
  line-height: 31px;
`;

export const SelectDropDown_container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 5px 0;
  width:100%;
  z-index: 6000;
`;

export const SelectReport = styled.select`
  padding: 0.25rem 0.25rem;
  border-radius: 10px;
  border: 0.8px solid #e8e8e8;
  // padding-right:15px;
  :focus {
    border-color: ${hoverSecondarySelect} !important;
    outline: 0;
    box-shadow: none;
  }
`;

export const Datalist = styled.datalist`
  padding: 0.75rem 0.95rem;

  border-radius: 10px;
  border: 0.8px solid #e8e8e8;
  // padding-right:15px;
  :focus {
    border-color: ${hoverSecondarySelect} !important;
    outline: 0;
    box-shadow: none;
  }
`;

export const Select = styled.select`
  padding: 0.75rem 0.95rem;

  border-radius: 10px;
  border: 0.8px solid #e8e8e8;
  // padding-right:15px;
  :focus {
    border-color: ${hoverSecondarySelect} !important;
    outline: 0;
    box-shadow: none;
  }
`;

export const CheckBoxContiner = styled.div`
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const CheckBoxContinerInput = styled.input`
  visibility: hidden;
  cursor: pointer;
`;

export const SidebarContainer = styled.nav`
  height: calc(100%-70px);
  // height:100px;
  font-size: 14px;
  font-weight: 500;
  width: 100%;

  .linkstyle {
    display: flex;
    flex-direction: column;
    text-decoration: none;
    width: fit;
    padding: 0.25rem 0.5rem;
    text-align: left;
  }

  .suboption {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    width: auto;
    margin: 0;
  }

  .active {
    background-color: ${primary_brand};
    color: white;
  }
  .profile_Link_act {
    width: fit-content;
    text-decoration: none;
    // margin-left: 20px;
    // padding: 3px 5px;
    background-color: ${primary_brand};
    color: white;
    border-radius: 5px;
    font-weight: 400;
  }

  .title {
    color: #4492cf;
  }

  .linkText {
    // width: fit-content;
    text-decoration: none;
    // margin-left: 20px;
    // padding: 3px 5px;
    // color: #4a4a68;
    // font-weight: 400;
    // border-radius: 5px;

    &:hover {
      background-color: #f2f2f2;
    }
  }
`;

export const Iconbtn = styled.button`
  display: flex;
  flex-direction: row;
  width: 100%;
  font-size: 14px;
  border: 0;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  padding: 7px 14px;
  color: ${primary_brand};
  background-color: white;
  margin: 5px 0;

  &:hover {
    background-color: ${primary_brand};
    color: white;
  }
`;
